import React from 'react';
import Grid from '@material-ui/core/Grid';

const CenterLayout = ({ grid = 11, children }) => {
  return (
    <Grid container justify='center'>
      <Grid item md={grid} xs>
        {children}
      </Grid>
    </Grid>
  );
};

export default CenterLayout;
